import { FC } from "react";

interface ReportsProps {}

const Reports: FC<ReportsProps> = () => (
  <>Reports</>
);

export default Reports;
